import { createStore } from 'effector';

export const $zoom7Hexagons = createStore([]);
$zoom7Hexagons.watch((state) => console.log('$zoom7Hexagons', state));

export const $zoom7StartHexagons = createStore([]);

export const $chosenZoom7Hexagon = createStore(null);
$chosenZoom7Hexagon.watch((state) => console.log('$chosenZoom7Hexagon', state));

export const $publicBusinessType = createStore('competitors_cnt_B1');
$publicBusinessType.watch((state) => console.log('$publicBusinessType', state));

export const $clickCoords = createStore(null);
$clickCoords.watch((state) => console.log('$clickCoords', state));

export const $showStops = createStore(false);

export const $attractLayer = createStore(null);

export const $chatPublicMessages = createStore([
  {
    text: `
        Добро пожаловать!<br/>
Я ваш виртуальный помощник по оценке локаций для вашего бизнеса. Я помогу вам анализировать данные, изучать метрики и работать с интерактивной картой.
      `,
    fromUser: false,
  },
]);

export const $infoModal = createStore(null);
